<script lang="ts">
import type {Area} from "#magnolia-layer/types/magnolia-types";
import type {SwiperOptions} from "swiper/types";

export default {
  inheritAttrs: false,
};

export type SwiperAreaProps = {
  content: Area;
  swiperOptions?: SwiperOptions;
};
</script>
<script lang="ts" setup>
import {EditableComponent} from "@magnolia/vue-editor";
import {
  register,
  type SwiperContainer,
  type SwiperSlide,
} from "swiper/element/bundle";

// register Swiper custom elements
register();

const {swiperOptions, content} = defineProps<SwiperAreaProps>();

const magnoliaContext = useMagnoliaContext();

const swiperEl = ref<SwiperContainer | null>(null);
onMounted(() => {
  const el = swiperEl.value;
  if (!el) return;
  Object.assign(el, {
    touchStartPreventDefault: !magnoliaContext.isMagnoliaEdit,
    ...swiperOptions,
  } as SwiperOptions);
  (el as SwiperContainer).initialize();
});

const components = computed(() => {
  return content ? content["@nodes"].map((nodeName) => content[nodeName]) : [];
});
</script>

<template>
  <swiper-container ref="swiperEl" init="false">
    <swiper-slide v-for="childContent in components" :key="childContent['@id']">
      <EditableComponent :key="childContent['@id']" :content="childContent" />
    </swiper-slide>
  </swiper-container>
</template>

<style lang="scss" scoped></style>
